import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import { observer } from "mobx-react-lite";
import React, { SyntheticEvent } from "react";
import { useModalStore } from "@/hooks/Modal/hooks";
import EditSkuPropertiesFilterModal from "@/scenes/OrderManagement/components/dialogs/EditSkuPropertiesFilterDialog/EditSkuPropertiesFilterModal";
import EditSkuPropertiesModal from "@/scenes/OrderManagement/components/dialogs/EditSkuPropertiesModal";
import { Tag } from "antd";
import OrderItemTagNameMap from "@/map/OrderItemTagNameMap";
import ShopAdvancedSettingModal from "../../../ListOptionsPane/ShopAdvancedSettingButton/ShopAdvancedSettingModal";

interface SkuPropertiesProps {
    orderItem: OrderItemDTO;

    order: OrderDTO;

    mergerOrder: OrderDTO;
}

const SkuProperties: React.FC<SkuPropertiesProps> = observer(({ orderItem, order, mergerOrder }) => {
    const modalStore = useModalStore();
    const skuProperties = orderItem.skuProperties || null;

    const localSkuProperties = orderItem.localSkuProperties || null;

    const displaySkuProperties = localSkuProperties || skuProperties;

    function onEditSkuPropertiesBtnClick(e: SyntheticEvent) {
        e.preventDefault();

        modalStore.openModal(EditSkuPropertiesModal, {
            order,
            mergerOrder,
            orderItem,
        });
    }

    function onEditSkuPropertiesFilterBtnClick(e: SyntheticEvent) {
        e.preventDefault();

        modalStore.openModal(EditSkuPropertiesFilterModal);
    }

    function handleOpenSettingModal() {
        modalStore.openModal(ShopAdvancedSettingModal, { shopId: order.shopId });
    }

    const showHideCarInfo = skuProperties?.includes("车型");

    return (
        <div>
            {displaySkuProperties ? (
                <p>
                    属性：
                    <span className="text-secondary break-spaces">{displaySkuProperties}</span>{" "}
                    {localSkuProperties && skuProperties && (
                        <span className="text-light small break-spaces">（原属性: {skuProperties})</span>
                    )}
                    <a
                        href="#"
                        className="small text-light show-tooltip ml10 mr5"
                        title="修改商品属性"
                        onClick={onEditSkuPropertiesBtnClick}
                    >
                        [修改]
                    </a>
                    <a
                        href="#"
                        className="small text-light show-tooltip"
                        title="设置商品属性过滤词"
                        onClick={onEditSkuPropertiesFilterBtnClick}
                    >
                        [过滤词]
                    </a>
                    {orderItem.tags?.map((tag) => {
                        return (
                            <Tag
                                variant="outlined"
                                color="#c00"
                                key={tag}
                                className="ml5"
                                style={{ fontSize: "12px", lineHeight: "14px", marginRight: 8 }}
                            >
                                {OrderItemTagNameMap[tag]}
                            </Tag>
                        );
                    })}
                    {showHideCarInfo && (
                        <a
                            href="#"
                            className="small text-light show-tooltip ml5"
                            title="设置隐藏车型"
                            onClick={handleOpenSettingModal}
                        >
                            [隐藏车型]
                        </a>
                    )}
                </p>
            ) : null}
        </div>
    );
});

export default SkuProperties;
